/* globals Swiper */

let wrap = '.slide-img';
let photo = '.slide-img__photo.swiper-container';
let list = {};

/**
 * Init swipe
 */
let initSwipe = () => {
    $(photo, wrap)
        .each((i, item) => {
            let idName = $(item)
                .attr('id');

            list[idName] = new Swiper(`#${idName}`, {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                simulateTouch: false,
                roundLengths: true,
                loop: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                allowTouchMove: false,
                cubeEffect: {
                    shadow: true,
                    slideShadows: true,
                    shadowOffset: 20,
                    shadowScale: 0.94,
                },
                pagination: {
                    el: `${wrap} .swiper-pagination`,
                    clickable: true,
                },
            });
        });
};

/**
 * Update for new show
 * @param idName
 * @param newList
 */
let updateSwipe = (idName, newList) => {
    list[idName].removeAllSlides();
    list[idName].prependSlide(newList);
    list[idName].update();
};

/**
 * Sets listens for events
 */
let setUpListens = () => {
    $(photo, wrap)
        .hover((e) => {
            let currentId = $(e.currentTarget).attr('id');

            // list[currentId].slideNext();
            list[currentId].autoplay.start();
        }, (e) => {
            let currentId = $(e.currentTarget).attr('id');

            list[currentId].autoplay.stop();
        });
};

/**
 * Init list
 */
let init = (outWrap) => {
    if ($(photo).length) {
        if (outWrap) {
            wrap = `${outWrap} ${wrap}`;
        }

        initSwipe();
        setUpListens();
    }
};

export {init as initImgSwipe, updateSwipe};
